/* RESPONSIBLE TEAM: team-standalone */

import type AppService from 'embercom/services/app-service';
import type IntlService from 'embercom/services/intl';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';

class FinAgentApi extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;

  get titleToken() {
    return this.intl.t('ai-agent.deploy.api');
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(FinAgentApi);
